import { Component, OnInit, EventEmitter, Input, Output, OnDestroy, ViewChild, inject } from '@angular/core';
import { NursingAuditService } from 'src/app/services/nursing-audit.service';
import { AuthService } from 'src/app/services/auth.service';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { DocumentService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { InvestigativeSummaryComponent } from '../investigative-summary/investigative-summary.component';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-notes-modal',
    templateUrl: './notes-modal.component.html',
    styleUrls: ['./notes-modal.component.css'],
    standalone: false
})
export class NotesModalComponent implements OnInit, OnDestroy {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private auditService = inject(NursingAuditService);
  authService = inject(AuthService);
  private resolutionCodingService = inject(ResolutionCodingService);
  documentService = inject(DocumentService);

  @Input() selectedRow: any = {};
  @Input() lookbackPeriod = 7;
  @Input() deId=false;
  @Output() shareAdminStatus = new EventEmitter();
  @Output() investigativeSummary = new EventEmitter();
  comment!: string;
  userMentions: object[] = [];
  taggedUsers: object[] = [];
  status!: string;
  comments: any;
  followUp:any={};
  followups:any;
  pollInterval:any;
  isLocked = false;
  isSubmitting = false;
  lockInfo:any = null
  lockMessage = '';
  totalCount:any = 0;
  originalFollowup:any;
  createdAt!: Date;
  //activeUsers:any[] = ['Arthur Fabella', 'Shawnna Bresina', 'Deborah El-Amin', 'Cody Eastman', 'Anthony Eyre', 'Mike Fink', 'Greg Griffin', 'Lorri Hall', 'Patrice Hasz', 'Wayne Hester', 'Michelle Hrapczak', 'Adam Hudson', 'Kevin Banks', 'Tim Johnson', 'Cassie Keene', 'Laura Dammann', 'Krystal Koball', 'Dan Martin', 'Lacey Morlan', 'Zachary Ness', 'Brooke Owens', 'PS.Pen3', 'Mike Ramirez', 'Kelly Sandvig', 'Paige Siegrist', 'Scott Tanner', 'Jenny Tempelis', 'Michelle Troutt', 'Alissa Voils', 'Sarah Vosburg', 'Carmen Fabella', 'DJ Moder', 'Dan Ngo', 'Patrice Hasz', 'Joe Crouse', 'Jun Fabella', 'Katharine Fiske', 'Kelly Shake', 'Mike Fink', 'Mitchell Leefers', 'ps.pen1', 'p2.pen2', 'Rob Wagnon', 'Kelly Sandvig', 'Steve Crouse', 'Sharon Rose', 'Jun Fabella', 'Test User'];
  userTag:any;
  activeUsers:string[] = [];
  documentSelector!: boolean;
  selectedDocuments: any[] = [];
  documents: any = null;
  showSummaryReport = false
  @ViewChild('InvestigativeSummary') InvestigativeSummaryComponent!: InvestigativeSummaryComponent;

  msgs!:[];
  @Output() completed = new EventEmitter<any>();
  openTab(num: any){
    this.documentService.tab = num;
  }

  ngOnInit(): void {
    this.followups = this.resolutionCodingService.getAuditFollowUpStatusOptions();
  }

  async getComments(rowData: any) {
    try {
      this.selectedRow = rowData;
      this.comment = "";
      this.taggedUsers = [];
      this.followUp = this.selectedRow.followUp;
      this.originalFollowup = this.selectedRow.followOld;
      this.createdAt = this.selectedRow.createdAt;
      this.auditService.getComments(rowData).subscribe((res)=>{
        this.comments = (res as any)["docs"].reverse();
        this.totalCount = (res as any)["count"];
      });


    } catch (err) { 
      this.logger.exception(err);
      this.comments = [];
    }
  }

  async closeDialog(){
    this.taggedUsers = []
    this.completed.emit(true);
  }

  submit() {
    if(this.isLocked || this.isSubmitting)
      return
    try {
      let oldFollowUp = ''
      if (this.selectedRow.followUpRecords.length > 0){
        oldFollowUp = this.selectedRow.followUpRecords[this.selectedRow.followUpRecords.length-1]['followUp']
      }
      else
        oldFollowUp = 'Open'
      const locGroup = this.selectedRow.locationGroupingString
      const adminGroup = this.selectedRow.adminGroup
      const followUpChanged = this.followUp !== oldFollowUp
      this.isSubmitting = true;
      this.auditService
        .submitComment(this.selectedRow["employeeName"],this.selectedRow["lanId"], "All", this.comment, this.followUp, this.selectedRow["_id"], this.lookbackPeriod, oldFollowUp, this.taggedUsers, locGroup, adminGroup, false, followUpChanged)
        .pipe(finalize(() => this.isSubmitting = false))
        //Update message alert MV2-445
        .subscribe(
          () => {
            this.taggedUsers = []
           const message= {
            life:5000,
             severity: 'success', 
             summary: 'Updated Successfully',
             detail: '',
            }
            this.completed.emit(message);
          },
          (err) => {
            const message= {
              life:5000,
              severity: 'error', 
              summary: 'Update Failed',
              detail: err.error.message,
             }
             this.completed.emit(message);
          }
        );
        //Update message alert MV2-445
      this.selectedRow.comment = this.comment;
      this.selectedRow.followUp = this.followUp;
    } catch {
      // Intentionally ignore here; API error is handled by the observable callback.
    }
  }

  startPolling(){
    this.stopPolling();
    this.pollInterval = setInterval(() => {
      this.checkStatus()
    }, environment.lockDuration||60);
    this.checkStatus()
  }

  stopPolling(){
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  checkStatus(){
    this.documentService.checkLockStatus(this.selectedRow["lanId"], "audit").subscribe((response)=>{
      this.isLocked = (response as any)["islocked"]
      this.lockInfo = response
      this.lockMessage = this.buildLockMessage();
    },
    ()=>{
      this.isLocked = true
      this.lockMessage = '';
    }
    )
  }

  private buildLockMessage(): string {
    if (this.lockInfo == null) return '';
    try {
      if (["", null].includes(this.lockInfo["lasteEditedBy"])) {
        return "";
      }
      if (!this.isLocked) {
        const dateObj = new Date(this.lockInfo["lastEditedAt"]);
        // Format as MM/DD/YYYY | HH:mm:ss (24-hour)
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const date = dateObj.getDate().toString().padStart(2, '0');
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours().toString().padStart(2, '0');
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');
        const seconds = dateObj.getSeconds().toString().padStart(2, '0');
        const createdDate = `${month}/${date}/${year} | ${hours}:${minutes}:${seconds}`;
        return (
          "Last Edited By (" +
          this.isDeId(this.lockInfo["lasteEditedBy"]) +
          " - " +
          createdDate +
          ")"
        );
      } else {
        if (["", null].includes(this.lockInfo["userName"])) {
          return "";
        }
        return "In Use By " + this.isDeId(this.lockInfo["userName"]);
      }
    } catch {
      return "";
    }
  }

  ngOnDestroy(){
    this.taggedUsers = []
    this.stopPolling();
  }

  shareAdminFollowUp(){
    this.shareAdminStatus.emit(this.selectedRow)
  }

  updateDocumentCount(count: any) {
    if(this.totalCount > 0){
      this.totalCount=this.totalCount - count;
    } else {
      this.totalCount = 0;
    }
  }

  updateCount(count: any){
    this.totalCount=this.totalCount + count;
  }

  OpenGSR(){
    this.investigativeSummary.emit(this.selectedRow)
  }

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }

  getHistoryBlurClass(){
    return this.deId ? 'blurred-content' : '';
  }

  getUserMentions(){
    this.authService.getActiveUsers().subscribe((res)=>{
      this.userMentions = (res as any)['users']
    })
  }

}
